/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DataTable as AbyssDataTable } from '@abyss/web/ui/DataTable';
import { useDataTable } from '@abyss/web/hooks/useDataTable';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Link } from '@abyss/web/ui/Link';
import { useOverlay } from '@abyss/web/hooks/useOverlay';
import { Layout } from '@abyss/web/ui/Layout';

export const SearchResults = ({
  setDisableContinueButton,
  setSelectedSearchData,
  getPageData,
  searchAttributes,
}) => {
  useEffect(() => {
    setDisableContinueButton(true);
  }, []);

  const drawer = useOverlay('speciality-drawer');
  const { data: drawerData } = drawer.getState();

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Address',
        accessor: 'address',
        Cell: ({ value }) => {
          return (
            <Layout.Stack
              css={{ flexDirection: 'column' }}
              alignItems="left"
              space={1}
            >
              <div>{value.streetAddress}</div>
              <div>
                {value.city}, {value.state} {value.zip}
              </div>
            </Layout.Stack>
          );
        },
        width: 165,
      },
      {
        Header: 'Phone',
        accessor: 'phone',
        Cell: ({ value }) => {
          return (
            <Layout.Stack
              css={{ flexDirection: 'column' }}
              alignItems="left"
              space={1}
            >
              <div>{value.primaryPhone}</div>
              <div>{value.fax}</div>
            </Layout.Stack>
          );
        },
        maxWidth: 90,
      },
      {
        Header: 'Speciality',
        accessor: 'speciality',
        Cell: ({ value }) => {
          const isArray = Array.isArray(value);
          if (!isArray) return value;
          if (value.length === 1) return value[0];
          return (
            <Layout.Stack
              css={{ flexDirection: 'column' }}
              alignItems="left"
              space={1}
            >
              <div>{value[0]}</div>
              <div>{value[1]}</div>
              <If condition={value.length > 2}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link size="$sm" onClick={() => drawer.open({ value })}>
                  See All
                </Link>
              </If>
            </Layout.Stack>
          );
        },
        minwidth: 175,
      },
      {
        Header: 'Tax ID',
        accessor: 'taxId',
        maxWidth: 90,
      },
      {
        Header: 'NPI',
        accessor: 'npi',
        maxWidth: 90,
      },
      {
        Header: 'Provider ID',
        accessor: 'providerId',
        maxWidth: 90,
      },
    ],
    []
  );

  const dataTableProps = useDataTable({
    singleSelection: true,
    initialColumns: columns,
    showPagination: true,
    highlightRowOnHover: true,
    minColumnWidth: 90,
    disableResizing: true,
    usePagination: true,
    apiPaginationCall: getPageData,
    disableApiCallOnLoad: true,
  });

  useEffect(() => {
    dataTableProps.reloadTableData();
  }, [searchAttributes]);

  useEffect(() => {
    if (Object.values(dataTableProps.state.selectedRowIds).some(Boolean)) {
      setDisableContinueButton(false);
      setSelectedSearchData(dataTableProps.state.selectedFlatRows[0]?.original);
    }
  }, [dataTableProps]);

  return (
    <React.Fragment>
      <AbyssDataTable title="Search results" tableState={dataTableProps} />
      <Drawer title="Speciality" model="speciality-drawer">
        <Drawer.Section>
          {drawerData &&
            drawerData.value.map(item => {
              return (
                <p key={item} style={{ marginBottom: 30 }}>
                  {item}
                </p>
              );
            })}
        </Drawer.Section>
      </Drawer>
    </React.Fragment>
  );
};

SearchResults.propTypes = {
  setDisableContinueButton: PropTypes.func,
  setSelectedSearchData: PropTypes.func,
  getPageData: PropTypes.func.isRequired,
  searchAttributes: PropTypes.shape({}).isRequired,
};
SearchResults.defaultProps = {
  setDisableContinueButton: () => {},
  setSelectedSearchData: () => {},
};
